import { IDashboardServices } from './datshboard.types'
import { http } from '@/shared/https'
import {ICallFilter} from '@/entities'

export class DashboardService implements IDashboardServices {

    /** get the list of initiative calls */
    getCalls(filter?: ICallFilter): any {
        let obj: any = Object.assign({}, filter);
        let q = new URLSearchParams(obj).toString();

        return http.get(`/api/Call?${q}`).then((resp: any) => {
            return [resp];
        });
    }

    getInitiativeCallList(filter?: ICallFilter): any {
        let obj: any = Object.assign({}, filter);
        let q = new URLSearchParams(obj).toString();

        return http.get(`/api/Call/List?${q}`).then((resp: any) => {
            return [resp];
        });
    }

    getDashboardFilter(type: string, section: string = ""): any {
        return http.get(`/api/Dashboard/Filter/${type}/${section}`)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp;
                } else {
                    return null;
                }
            })
            .catch(function (error) {
                return null;
            });
    }

    getInternalDashboard(action: String, filterBy: any): any {
        return http.post(`/api/Dashboard/Internal/${action}`, filterBy)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp;
                } else {
                    return null;
                }
            })
            .catch(function (error) {
                return null;
            });
    }

    getExternalDashboard(action: String, filterBy: any): any {
        return http.post(`/api/Dashboard/External/${action}`, filterBy)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp;
                } else {
                    return null;
                }
            })
            .catch(function (error) {
                return null;
            });
    }

    getAppInfo(): any {
        let appInfo: any = {"Version": "1.0.0"};

        return http.get(`api/Dashboard/AppInfo`)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    appInfo.Version = resp.data.Version;
                    appInfo.Date = resp.data.Date;
                }
                return appInfo;
        });
    }

}